export class Bg {
  constructor() {
    this.complete = false;

    window.addEventListener('load', this.border);
    window.addEventListener('scroll', this.border);
  }

  border() {
    if(!this.complete) {
      const pos = document.querySelector('.bg');
      const frame = document.querySelector('.frame');
      const rect = pos.getBoundingClientRect();
      const top = window.pageYOffset || document.documentElement.scrollTop;
      const height = frame.clientHeight / 2
      const fixedPos =  rect.top + top - height;
      let width;

      if (window.pageYOffset > fixedPos) {
        width = (window.pageYOffset - fixedPos) / 10;
        width = Math.floor(width * 100) / 100;
        width = 100 - width;

        frame.style.borderWidth = width +  'px';

        if(width <= 0) {
          frame.style.borderWidth =  '0px';
          this.complete = true;
        }
      }
    }
  }

}
